export default __webpack_public_path__ + "static/media/tree16.1738b494.png";